export default __webpack_public_path__ + "static/media/LinkIcon.bf203069.svg";